<template>
  <div>
    <div
      v-if="loading"
      class="loading"
    >
      <p>Loading...</p>
      <LoadingSpinner />
    <!-- LoadingSpinner burada kullanılıyor -->
    </div>
    <div v-if="serviceAd">
      <div
        v-if="error"
        class="error"
      >
        {{ error }}
      </div>
      <section class="header anim-grad-box service-header">
        <div class="inner-header flex">
          <h1 class="mt-4">
            <img
              :src="serviceAd.coverImage"
              alt=""
            >
          </h1>
        </div>
      </section>

      <section class="gray-section no-top-padding">
        <div class="containers">
          <div class="row">
            <div class="col-md-8">
              <!-- list-single-main-wrapper -->
              <div
                id="sec2"
                class="list-single-main-wrapper fl-wrap"
              >
                <!-- list-single-header -->
                <div class="list-single-header list-single-header-inside fl-wrap">
                  <div class="containers">
                    <div class="list-single-header-item">
                      <div class="row">
                        <div class="col-md-8">
                          <div class="list-single-header-item-opt fl-wrap">
                            <div class="list-single-header-cat fl-wrap">
                              <a
                                href="#"
                                class="hotel-link"
                              >Boarding</a>
                            </div>
                          </div>
                          <h2>
                            {{}} <span> - Owned By </span><a href="author-single.html">{{ serviceAd.displayName }}</a>
                          </h2>
                          <span class="section-separator" />
                          <div
                            class="listing-rating card-popup-rainingvis"
                            data-starrating2="5"
                          >
                            <i class="fa fa-star" /><i class="fa fa-star" />
                            <i class="fa fa-star" /><i class="fa fa-star" />
                            <i class="fa fa-star" />
                            <span>({{ serviceAd.reviewsCount }} reviews)</span>
                          </div>
                          <div class="list-post-counter single-list-post-counter">
                            <span> {{ serviceAd.likesCount }} </span><i class="fa fa-heart" />
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="fl-wrap list-single-header-column">
                            <span class="viewed-counter"><i class="fa fa-eye" /> Viewed - {{ serviceAd.viewCount }}
                            </span>
                            <a
                              class="custom-scroll-link"
                              href="#javascript:void(0)"
                            ><i class="fa fa-hand-o-right" />Add Review
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- list-single-header end -->
                <div class="list-single-facts fl-wrap gradient-bg">
                  <!-- inline-facts -->
                  <div class="inline-facts-wrap">
                    <div class="inline-facts">
                      <i class="fa fa-home" />
                      <div class="milestone-counter">
                        <div class="stats animaper">
                          <div
                            class="num"
                            data-content="0"
                            data-num="45"
                          >
                            45
                          </div>
                        </div>
                      </div>
                      <h6>Hotel Rooms</h6>
                    </div>
                  </div>
                  <!-- inline-facts end -->
                  <!-- inline-facts  -->
                  <div class="inline-facts-wrap">
                    <div class="inline-facts">
                      <i class="fa fa-male" />
                      <div class="milestone-counter">
                        <div class="stats animaper">
                          <div
                            class="num"
                            data-content="0"
                            data-num="2557"
                          >
                            2557
                          </div>
                        </div>
                      </div>
                      <h6>Happy customers every year</h6>
                    </div>
                  </div>
                  <!-- inline-facts end -->
                  <!-- inline-facts  -->
                  <div class="inline-facts-wrap">
                    <div class="inline-facts">
                      <i class="fa fa-cutlery" />
                      <div class="milestone-counter">
                        <div class="stats animaper">
                          <div
                            class="num"
                            data-content="0"
                            data-num="5"
                          >
                            5
                          </div>
                        </div>
                      </div>
                      <h6>Restorans Inside</h6>
                    </div>
                  </div>
                <!-- inline-facts end -->
                </div>
                <div class="list-single-main-item fl-wrap">
                  <div class="list-single-main-item-title fl-wrap">
                    <h3>About {{ serviceAd.companyName }}</h3>
                  </div>
                  <p>
                    {{ serviceAd.companyDescription }}
                  </p>
                  <span class="fw-separator" />
                  <div class="list-single-main-item-title fl-wrap">
                    <h3>Services</h3>
                  </div>
                  <div class="listing-features fl-wrap">
                    <ul>
                      <li
                        v-for="(serviceItem, index) in serviceAd.services"
                        :key="index"
                        :data-microtip-position="'top'"
                        :data-tooltip="serviceItem"
                      >
                        <i class="fa fa-award" /> {{ serviceItem }}
                      </li>
                    </ul>
                  </div>
                  <span class="fw-separator" />
                  <div class="list-single-main-item-title fl-wrap">
                    <h3>Tags</h3>
                  </div>
                  <div
                    v-for="(serviceItem, index) in serviceAd.services"
                    :key="index"
                    :data-microtip-position="'top'"
                    :data-tooltip="serviceItem"
                    class="list-single-tags tags-stylwrap"
                  >
                    <a href="javascript:void(0)">{{ serviceItem }}</a>
                  </div>
                </div>
                <!-- list-single-main-item-->
                <div
                  id="sec3"
                  class="list-single-main-item fl-wrap"
                >
                  <div class="list-single-main-item-title fl-wrap">
                    <h3>Gallery - Photos</h3>
                  </div>
                  <div style="height: 30px" />
                  <!-- gallery-items   -->
                  <div
                    class="gallery-items grid-small-pad list-single-gallery three-coulms lightgallery"
                    style="position: relative; height: 337.844px"
                  >
                    <!-- 1 -->
                    <div
                      v-for="(image, index) in serviceAd.galleryImages"
                      :key="index"
                      class="gallery-item"
                    >
                      <div class="grid-item-holder">
                        <div class="box-item">
                          <img
                            :src="image"
                            alt="Gallery image"
                          >
                          <a
                            href="javascript:void(0)"
                            class="gal-link"
                            @click.prevent
                          ><i class="fa fa-search" /></a>
                        </div>
                      </div>
                    </div>
                  <!-- 1 end -->
                  </div>
                <!-- end gallery items -->
                </div>
              <!-- list-single-main-item end -->
              </div>
            </div>
            <!--box-widget-wrap -->
            <div class="col-md-4">
              <div class="box-widget-wrap">
                <!--box-widget-item -->
                <div class="box-widget-item fl-wrap">
                  <div class="box-widget-item-header">
                    <h3>Hosted by : Petqueen</h3>
                  </div>
                  <div class="box-widget list-author-widget">
                    <div class="list-author-widget-header shapes-bg-small color-bg fl-wrap">
                      <span class="list-author-widget-link"><a href="author-single.html"> {{ serviceAd.displayName }} </a></span>
                      <img
                        :src="serviceAd.photoURL"
                        alt=""
                      >
                    </div>
                    <div class="box-widget-content">
                      <div class="list-author-widget-text">
                        <div class="list-author-widget-contacts">
                          <ul>
                            <li>
                              <span><i class="fa fa-phone" /> Phone :</span>
                              <a href="#"> {{ serviceAd.phoneNumber }} </a>
                            </li>
                            <li>
                              <span><i class="fa fa-envelope-o" /> Mail :</span>
                              <a href="#">{{ serviceAd.email }}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--box-widget-item end -->
                <!--box-widget-item -->
                <div class="box-widget-item fl-wrap">
                  <div class="box-widget-item-header">
                    <h3>Working Hours :</h3>
                  </div>
                  <div class="box-widget opening-hours">
                    <div class="box-widget-content">
                      <span class="current-status"><i class="fa fa-clock-o" /> Now Open</span>
                      <ul>
                        <li>
                          <span class="opening-hours-day">Monday </span><span class="opening-hours-time">{{ serviceAd.workingHours.monday.open }} -
                            {{ serviceAd.workingHours.monday.close }}</span>
                        </li>
                        <li>
                          <span class="opening-hours-day">Tuesday </span><span class="opening-hours-time">{{ serviceAd.workingHours.tuesday.open }} -
                            {{ serviceAd.workingHours.tuesday.close }}</span>
                        </li>
                        <li>
                          <span class="opening-hours-day">Wednesday </span><span class="opening-hours-time">{{ serviceAd.workingHours.wednesday.open }} -
                            {{ serviceAd.workingHours.wednesday.close }}</span>
                        </li>
                        <li>
                          <span class="opening-hours-day">Thursday </span><span class="opening-hours-time">{{ serviceAd.workingHours.thursday.open }} -
                            {{ serviceAd.workingHours.thursday.close }}</span>
                        </li>
                        <li>
                          <span class="opening-hours-day">Friday </span><span class="opening-hours-time">{{ serviceAd.workingHours.friday.open }} -
                            {{ serviceAd.workingHours.friday.close }}</span>
                        </li>
                        <li>
                          <span class="opening-hours-day">Saturday </span><span class="opening-hours-time">{{ serviceAd.workingHours.saturday.open }} -
                            {{ serviceAd.workingHours.saturday.close }}</span>
                        </li>
                        <li>
                          <span class="opening-hours-day">Sunday </span><span class="opening-hours-time">{{ serviceAd.workingHours.sunday.open }} -
                            {{ serviceAd.workingHours.sunday.close }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <!--box-widget-item end -->
                <!--box-widget-item -->

                <!--box-widget-item end -->

                <!--box-widget-item -->
                <div class="box-widget-item fl-wrap">
                  <div class="box-widget-item-header">
                    <h3>Location / Contacts :</h3>
                  </div>
                  <div class="box-widget">
                    <div class="map-containers">
                      <div
                        id="singleMap"
                        data-latitude="40.7427837"
                        data-longitude="-73.11445617675781"
                        data-maptitle="Our Location"
                      >
                        <div style="height: 100%; width: 100%">
                          <div style="overflow: hidden" />
                        </div>
                      </div>
                    </div>
                    <div class="box-widget-content">
                      <div class="list-author-widget-contacts list-item-widget-contacts">
                        <ul>
                          <li>
                            <span><i class="fa fa-map-marker" /> Adress :</span>
                            <a href="#"> {{ serviceAd.address }}</a>
                          </li>
                          <li>
                            <span><i class="fa fa-phone" /> Phone :</span>
                            <a href="#">{{ serviceAd.phoneNumber }}</a>
                          </li>
                          <li>
                            <span><i class="fa fa-envelope-o" /> Mail :</span>
                            <a href="#">{{ serviceAd.email }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              <!--box-widget-item end -->
              </div>
            </div>
          <!--box-widget-wrap end -->
          </div>
        </div>
      </section>
      <section class="gray-section no-top-padding">
        <div class="containers">
          <div class="row">
            <div class="col-md-8">
              <!-- list-single-main-wrapper -->
              <div
                id="sec2"
                class="list-single-main-wrapper fl-wrap"
              >
                <!-- list-single-main-item -->
                <div
                  id="sec4"
                  class="list-single-main-item fl-wrap"
                >
                  <div class="list-single-main-item-title fl-wrap">
                    <h3>Item Reviews - <span> 3 </span></h3>
                  </div>
                  <div class="reviews-comments-wrap">
                    <!-- reviews-comments-item -->
                    <div class="reviews-comments-item">
                      <div class="review-comments-avatar">
                        <img
                          src="https://dummyimage.com/200x200/888/fff.jpg"
                          alt=""
                        >
                      </div>
                      <div class="reviews-comments-item-text">
                        <h4><a href="#">Jessie Manrty</a></h4>
                        <div
                          class="listing-rating card-popup-rainingvis"
                          data-starrating2="5"
                        >
                          <i class="fa fa-star" /><i class="fa fa-star" /><i class="fa fa-star" /><i class="fa fa-star" /><i class="fa fa-star" />
                        </div>
                        <div class="clearfix" />
                        <p>
                          " Commodo est luctus eget. Proin in nunc laoreet justo volutpat blandit
                          enim. Sem felis, ullamcorper vel aliquam non, varius eget justo. Duis quis
                          nunc tellus sollicitudin mauris. "
                        </p>
                        <span class="reviews-comments-item-date"><i class="fa fa-calendar-check-o" />27 May 2018</span>
                      </div>
                    </div>
                  <!--reviews-comments-item end-->
                  </div>
                </div>
              <!-- list-single-main-item end -->
              </div>
            </div>
          </div>
        </div>
      </section>
      <div style="height: 50px; color: white">
        .
      </div>
    </div>
  </div>
</template>

<script setup>
  /* eslint-disable */
  import { onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useGetServiceAd } from '@/composables/getServiceAd'; // useGetServiceAd olarak import edildi
  import LoadingSpinner from '@/components/LoadingSpinner.vue'; // LoadingSpinner import edildi

  // Route'dan servis ID'sini al
  const route = useRoute();
  const serviceId = route.params.id;

  // Composables'tan gerekli değerleri al
  const { serviceAd, error, loading, fetchServiceAd } = useGetServiceAd(serviceId); // useGetServiceAd kullanıldı

  // Sayfa yüklendiğinde servis detaylarını çek
  onMounted(() => {
    fetchServiceAd(); // fetchServiceAd kullanıldı
  });
</script>

<style scoped>
  html,
  body,
  div,
  span,
  applet,
  object,
  iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  blockquote,
  pre,
  a,
  abbr,
  acronym,
  address,
  big,
  cite,
  code,
  del,
  dfn,
  em,
  font,
  img,
  ins,
  kbd,
  q,
  s,
  samp,
  small,
  strike,
  strong,
  sub,
  sup,
  tt,
  var,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  caption,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td {
    border: none;
    outline: 0;
    font-weight: inherit;
    font-style: inherit;
    font-size: 100%;
    font-family: inherit;
    vertical-align: baseline;
    text-decoration: none;
    margin: 0;
    padding: 0;
  }

  .clearfix:before,
  .clearfix:after,
  .containers:before,
  .containers:after,
  .containers-fluid:before,
  .containers-fluid:after,
  .row:before,
  .row:after {
    content: ' ';
    display: table;
  }

  .col-xs-1,
  .col-sm-1,
  .col-md-1,
  .col-lg-1,
  .col-xs-2,
  .col-sm-2,
  .col-md-2,
  .col-lg-2,
  .col-xs-3,
  .col-sm-3,
  .col-md-3,
  .col-lg-3,
  .col-xs-4,
  .col-sm-4,
  .col-md-4,
  .col-lg-4,
  .col-xs-5,
  .col-sm-5,
  .col-md-5,
  .col-lg-5,
  .col-xs-6,
  .col-sm-6,
  .col-md-6,
  .col-lg-6,
  .col-xs-7,
  .col-sm-7,
  .col-md-7,
  .col-lg-7,
  .col-xs-8,
  .col-sm-8,
  .col-md-8,
  .col-lg-8,
  .col-xs-9,
  .col-sm-9,
  .col-md-9,
  .col-lg-9,
  .col-xs-10,
  .col-sm-10,
  .col-md-10,
  .col-lg-10,
  .col-xs-11,
  .col-sm-11,
  .col-md-11,
  .col-lg-11,
  .col-xs-12,
  .col-sm-12,
  .col-md-12,
  .col-lg-12 {
    position: relative;
    min-height: 1px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .fl-wrap {
    float: left;
    width: 100%;
    position: relative;
  }

  .info-button:hover,
  .footer-social li a,
  .lost_password a:hover,
  .nav-holder nav li a.act-link,
  .nav-holder nav li a:hover,
  .testi-text:before,
  .testi-text:after,
  #footer-twiit .timePosted a:before,
  .map-popup-location-phone i,
  .map-popup-location-info i,
  .dark-header .nav-holder nav li ul a:hover,
  .main-register h3 span strong,
  .main-register label i,
  .listsearch-header h3 span,
  .listing-view-layout li a.active,
  .listsearch-input-text label i,
  .distance-title i,
  .listsearch-input-item i,
  .filter-tags input:checked:after,
  .more-filter-option:hover,
  .distance-title span,
  .selectbox li.selected,
  .mapzoom-in:hover,
  .mapzoom-out:hover,
  .footer-widget .widget-posts-date,
  .listsearch-input-text a.loc-act,
  .list-single-header-contacts li i,
  .viewed-counter i,
  .list-single-header-column .custom-scroll-link i,
  .list-single-header-cat span i,
  .scroll-nav-wrapper .scroll-nav li a.act-scrlink,
  .listing-features li i,
  .list-author-widget-contacts li span i,
  .list-author-widget-contacts li a:hover,
  .current-status i,
  .scroll-nav-wrapper .save-btn i,
  .list-single-contacts li i,
  .list-post-counter.single-list-post-counter i,
  .reviews-comments-item-date i,
  .list-single-main-item-title span,
  .custom-form label i,
  .custom-form .quantity span i,
  .box-widget.widget-posts .widget-posts-date i,
  .box-widget.widget-posts .widget-posts-descr a:hover,
  .team-social li a,
  .team-info h3 a:hover,
  .section-title h2 a,
  section.color-bg .header-sec-link a:hover,
  .user-profile-menu li a.user-profile-act,
  .user-profile-menu li a:hover,
  .log-out-btn,
  .pass-input-wrap span,
  .header-user-name:before,
  .header-user-menu ul li a:hover,
  .reply-mail a,
  .dashboard-message-text h4 span,
  .profile-edit-page-header .breadcrumbs span,
  .profile-edit-page-header .breadcrumbs a:hover,
  .reviews-comments-item-link,
  .fuzone:hover .fu-text i,
  .radio input[type='radio']:checked + span:before,
  .booking-details a,
  .booking-details span.booking-text,
  .dashboard-listing-table-address i,
  .post-opt li i,
  .list-single-main-item-title h3 a:hover,
  .post-opt li a:hover,
  .post-link i,
  .post-link:hover,
  .tl-text i,
  .tl-text h3,
  .features-box .time-line-icon i,
  .features-box h3,
  .images-collage-title span,
  .process-item .time-line-icon i,
  .card-post-content h3 a:hover,
  .card-listing .list-post-counter i,
  .section-subtitle,
  .process-item:hover .process-count,
  .footer-contacts li i,
  .main-search-input-item.location a,
  .card-listing .geodir-category-location i,
  .show-reg-form:hover,
  .show-search-button i,
  .menusb li a i,
  .menusb a.back:before,
  .menusb a.act-link,
  .sp-cont,
  .list-single-tags a:hover,
  .card-listing .geodir-category-content h3 a:hover,
  #footer-twiit a:hover,
  .subscribe-message.error a,
  .share-holder.hid-share .share-container .share-icon,
  .footer-contacts li a:hover,
  .listing-title a:hover,
  #contact-form #message p strong,
  .claim-widget-link a,
  .dashboard-list-box.activities .dashboard-message-text i,
  .flatWeatherPlugin ul.wiForecasts li.wi,
  .chat-widget-button i,
  .chat-widget_input button,
  .scrollContorl i,
  #progressbar li span,
  .log-massage a,
  .filter-tags a {
    color: #70243b;
  }

  img {
    border: 0;
    -ms-interpolation-mode: bicubic;
    vertical-align: middle;
  }

  section {
    float: left;
    width: 100%;
    position: relative;
    padding: 80px 0;
    overflow: hidden;
    z-index: 1;
  }

  section.no-top-padding {
    padding: 50px 0;
  }

  .containers {
    max-width: 1224px;
    width: 92%;
    margin: 0 auto;
    position: relative;
    z-index: 5;
  }

  .row {
    margin-left: -15px;
    margin-right: -15px;
  }

  .list-single-header.list-single-header-inside {
    padding-bottom: 0;
    padding: 30px 0;
    background: #fff;
    border-radius: 6px;
    border: 1px solid #eee;
  }

  .list-single-header {
    z-index: 10;
    padding-bottom: 50px;
  }

  .list-single-header-cat {
    margin-bottom: 20px;
  }

  .list-single-header-cat a {
    color: #fff;
    border-radius: 4px;
    padding: 10px 25px;
    float: left;
  }

  .list-single-header-cat a {
    background-color: #70243b;
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#70243b), to(#49ceff));
    background: -webkit-linear-gradient(top, #70243b, #49ceff);
    background: -moz-linear-gradient(top, #70243b, #49ceff);
    background: -ms-linear-gradient(top, #70243b, #49ceff);
    background: -o-linear-gradient(top, #70243b, #49ceff);
  }

  .list-single-header-cat a {
    color: #fff;
    border-radius: 4px;
    padding: 10px 25px;
    float: left;
  }

  .list-single-header-inside .list-single-header-item h2 {
    color: #334e6f;
    font-size: 36px;
  }

  .list-single-header-item h2 {
    float: left;
    width: 100%;
    text-align: left;
    color: #fff;
    font-size: 46px;
    font-weight: 700;
    padding-bottom: 15px;
  }

  .list-single-header-item h2 span,
  .list-single-header-item h2 a {
    font-size: 13px;
    font-weight: 400;
  }

  .list-single-header-item h2 a {
    font-weight: 600;
    color: #5ecfb1;
  }

  .list-single-header-item h2 span,
  .list-single-header-item h2 a {
    font-size: 13px;
    font-weight: 400;
  }

  section.gray-section .section-separator {
    background: #f9f9f9;
  }

  .list-single-header .section-separator {
    margin-top: 0;
  }

  .section-separator {
    float: left;
    width: 100%;
    position: relative;
    margin: 20px 0;
  }

  .list-single-header .section-separator:before {
    left: 26px;
  }

  .section-separator:before {
    content: '';
    position: absolute;
    left: 50%;
    top: 0;
    height: 4px;
    margin-left: -25px;
    width: 50px;
    border-radius: 3px;
    background: #70243b;
  }

  .list-single-header-item .listing-rating {
    float: left;
    margin-top: 10px;
  }

  .list-single-header-item .listing-rating i {
    float: left;
    margin-right: 6px;
  }

  .listing-rating i {
    color: #facc39;
  }

  .list-single-header.list-single-header-inside .list-single-header-item .listing-rating span {
    color: #666;
  }

  .list-single-header-item .listing-rating span {
    color: rgba(255, 255, 255, 0.71);
    float: left;
    margin-left: 12px;
    position: relative;
    top: -2px;
  }

  .list-single-header-inside .list-post-counter.single-list-post-counter {
    border: 1px solid #eee;
    color: #666;
  }

  .list-post-counter.single-list-post-counter {
    position: relative;
    float: left;
    color: #fff;
    cursor: pointer;
    font-weight: 700;
    padding: 6px 10px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.21);
    margin-left: 20px;
    top: 2px;
  }

  .list-post-counter.single-list-post-counter i {
    padding-left: 10px;
    color: #f4454c;
  }

  .hotel-link {
    background-color: #70243b;
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#70243b), to(#49ceff));
    background: -webkit-linear-gradient(top, #70243b, #49ceff);
    background: -moz-linear-gradient(top, #70243b, #49ceff);
    background: -ms-linear-gradient(top, #70243b, #49ceff);
    background: -o-linear-gradient(top, #70243b, #49ceff);
    color: #fff;
    border-radius: 4px;
    padding: 10px 25px;
    float: left;
  }

  .list-single-header-inside .list-single-header-column {
    margin-top: 0;
  }

  .list-single-header-column {
    position: relative;
    margin-top: 20px;
  }

  .list-single-header-inside .list-single-header-column .viewed-counter,
  .list-single-header-inside .list-single-header-column .custom-scroll-link {
    float: right;
    border: 1px solid #eee;
    border-radius: 4px;
    color: #999;
    margin-bottom: 12px;
  }

  .list-single-header-column .viewed-counter,
  .list-single-header-column .custom-scroll-link {
    float: right;
    color: #fff;
    padding: 7px 12px;
    border-radius: 20px;
    margin-right: 10px;
    position: relative;
    top: 8px;
    border: 1px solid rgba(255, 255, 255, 0.41);
    border-radius: 4px;
    background: rgba(255, 255, 255, 0.11);
  }

  .gradient-bg,
  .listing-geodir-category,
  .list-single-header-cat a,
  .box-widget-item .list-single-tags a:hover,
  .nav-holder nav li a:before {
    background-image: -webkit-linear-gradient(top, rgb(112 36 59), rgb(255 73 132));
    background-position-x: initial;
    background-position-y: initial;
    background-size: initial;
    background-repeat: initial;
    background-attachment: initial;
    background-origin: initial;
    background-clip: initial;
    background-color: initial;
    background-color: #70243b;
    background: -webkit-gradient(linear, 0% 0%, 0% 100%, from(#70243b), to(#49ceff));
    background: -webkit-linear-gradient(top, #70243b, #49ceff);
    background: -moz-linear-gradient(top, #70243b, #49ceff);
    background: -ms-linear-gradient(top, #70243b, #49ceff);
    background: -o-linear-gradient(top, #70243b, #49ceff);
  }

  .inline-facts {
    text-align: center;
  }

  .list-single-facts {
    margin: 10px 0 20px;
    padding: 20px 30px;
    border-radius: 6px;
  }

  .list-single-facts .inline-facts-wrap {
    width: 33.3%;
    float: left;
    color: #fff;
    position: relative;
  }

  .list-single-facts .inline-facts-wrap:before {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    width: 1px;
    height: 70px;
    margin-top: -35px;
    background: rgba(255, 255, 255, 0.21);
  }

  .list-single-facts .inline-facts-wrap i {
    font-size: 30px;
    width: 80px;
    height: 80px;
    line-height: 80px;
    border-radius: 100%;
    background: rgba(255, 255, 255, 0.11);
    border: 1px solid rgba(255, 255, 255, 0.21);
  }

  .list-single-facts .inline-facts-wrap .num,
  .single-facts .inline-facts-wrap .num {
    display: block;
    margin: 12px 0;
    font-size: 30px;
    font-weight: 800;
  }

  .list-single-facts .inline-facts-wrap h6,
  .single-facts .inline-facts-wrap h6 {
    color: rgba(255, 255, 255, 0.71);
    font-size: 13px;
    font-weight: 500;
  }

  .list-single-main-item {
    padding: 30px 30px;
    border-radius: 100%;
    background: #fff;
    border-radius: 10px;
    border: 1px solid #eee;
    margin-bottom: 20px;
  }

  .list-single-main-item-title {
    margin: 0 0 20px 0;
  }

  .list-single-main-item-title h3 {
    color: #334e6f;
    text-align: left;
    font-size: 18px;
    font-weight: 600;
  }

  .list-single-main-item p {
    text-align: left;
    color: #878c9f;
  }

  p {
    font-size: 12px;
    line-height: 24px;
    padding-bottom: 10px;
    font-weight: 500;
    color: #878c9f;
  }

  .fw-separator {
    float: left;
    width: 100%;
    margin: 25px 0;
    height: 1px;
    background: #eee;
  }

  .listing-features li {
    float: left;
    width: 33.3%;
    text-align: left;
    margin-bottom: 15px;
    font-size: 13px;
    color: #888da0;
    font-weight: 600;
  }

  .listing-features li i {
    padding-right: 10px;
    font-size: larger;
  }

  .tags-stylwrap a {
    float: left;
    padding: 10px 20px;
    border-radius: 4px;
    color: #888da0;
    font-weight: 500;
    margin-right: 6px;
    border: 1px solid #eee;
  }

  .accordion {
    float: left;
    width: 100%;
    position: relative;
  }

  .accordion a.toggle.act-accordion {
    color: #fff;
    border-color: transparent;
  }

  .accordion a.toggle {
    border: 1px solid #eee;
    padding: 18px 30px;
    float: left;
    width: 100%;
    position: relative;
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: left;
    font-weight: 500;
    font-size: 13px;
    -webkit-transition: all 300mslinear;
    -moz-transition: all 300ms linear;
    transition: all 300mslinear;
    margin-bottom: 15px;
  }

  .accordion a.toggle.act-accordion {
    color: #fff;
    border-color: transparent;
    background: #70243b;
  }

  .accordion a.toggle {
    border: 1px solid #eee;
    padding: 18px 30px;
    float: left;
    width: 100%;
    position: relative;
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    text-align: left;
    font-weight: 500;
    font-size: 13px;
    -webkit-transition: all 300mslinear;
    -moz-transition: all 300ms linear;
    transition: all 300mslinear;
    margin-bottom: 15px;
  }

  .accordion-inner.visible {
    display: block;
  }

  .accordion-inner {
    display: none;
    float: left;
    width: 100%;
    position: relative;
    padding: 15px 30px;
    background: #fff;
    margin: 0 0 15px;
    text-align: left;
  }

  .list-single-main-item-title {
    margin: 0 0 20px 0;
  }

  .list-single-main-item-title h3 {
    color: #334e6f;
    text-align: left;
    font-size: 18px;
    font-weight: 600;
  }

  .reviews-comments-wrap {
    display: inline-table;
    margin-top: 30px;
  }

  .reviews-comments-item {
    padding: 0 0 30px 110px;
    position: relative;
    float: left;
    margin-bottom: 40px;
    width: 100%;
    border-bottom: 1px solid #eee;
  }

  .review-comments-avatar {
    position: absolute;
    top: 0;
    left: 20px;
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 100%;
  }

  .review-comments-avatar img {
    width: 80px;
    height: 80px;
    float: left;
  }

  .reviews-comments-item-text {
    float: left;
    width: 100%;
    position: relative;
    padding: 0 20px;
  }

  .reviews-comments-item-text h4 {
    text-align: left;
    padding-bottom: 25px;
    float: left;
    font-size: 16px;
    font-weight: 500;
  }

  .reviews-comments-item-text .listing-rating {
    float: right;
  }

  .reviews-comments-item-text .listing-rating i {
    float: left;
    margin-right: 6px;
    font-size: 12px;
  }

  .listing-rating i {
    color: #facc39;
  }

  .reviews-comments-item-text p {
    text-align: left;
  }

  .list-single-main-item p {
    text-align: left;
    color: #878c9f;
  }

  .reviews-comments-item-date {
    float: left;
    margin-top: 18px;
    font-weight: 300;
    color: #999;
    font-size: 13px;
  }

  .reviews-comments-item-date i {
    margin-right: 10px;
  }

  .box-widget-item {
    margin-bottom: 30px;
  }

  .box-widget-item-header {
    display: block;
    margin-bottom: 22px;
  }

  .box-widget-item-header h3 {
    text-align: left;
    font-size: 18px;
    font-weight: 600;
    color: #334e6f;
  }

  .box-widget {
    background: #fff;
    border-radius: 10px;
    border: 1px solid #eee;
    overflow: hidden;
    float: left;
    width: 100%;
  }

  .box-widget-content {
    float: left;
    width: 100%;
    position: relative;
    padding: 25px 30px 30px;
    font-size: 12px;
  }

  .current-status {
    float: left;
    width: 100%;
    margin-bottom: 20px;
    text-align: left;
    font-weight: 700;
    color: #5ecfb1;
    font-size: 15px;
  }

  .current-status i {
    color: #ccc;
    font-size: 16px;
    padding-right: 30px;
    position: relative;
    top: 3px;
  }

  .opening-hours ul li {
    width: 100%;
    margin-bottom: 15px;
    float: left;
    padding-bottom: 15px;
    color: #878c9f;
    border-bottom: 1px solid #eee;
  }

  .opening-hours ul li span.opening-hours-day {
    float: left;
    color: #878c9f;
    font-weight: 600;
  }

  .opening-hours ul li span.opening-hours-time {
    float: right;
    font-weight: 500;
    color: #999;
  }

  .custom-form {
    float: left;
    width: 100%;
    position: relative;
  }

  .custom-form label {
    float: left;
    position: relative;
    width: 100%;
    text-align: left;
    font-weight: 500;
    color: #666;
  }

  .custom-form label i {
    padding-right: 12px;
    font-size: 14px;
    position: absolute;
    top: 16px;
    left: 20px;
    color: #70243b;
  }

  .custom-form textarea,
  .custom-form input[type='text'],
  .custom-form input[type='email'],
  .custom-form input[type='password'],
  .custom-form input[type='button'] {
    float: left;
    border: 1px solid #eee;
    background: #f9f9f9;
    width: 100%;
    padding: 15px 20px 15px 55px;
    border-radius: 6px;
    color: #666;
    font-size: 13px;
    appearance: none;
  }

  .custom-form input {
    margin-bottom: 20px;
  }

  .custom-form .quantity span i {
    padding-right: 10px;
    font-size: 14px;
  }

  .custom-form .quantity span {
    float: left;
    position: relative;
    top: 16px;
    padding-left: 19px;
  }

  .quantity-item {
    float: right;
  }

  .custom-form .quantity input.minus {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
  }

  .custom-form .quantity input.minus,
  .custom-form .quantity input.plus,
  .custom-form .quantity input.qty {
    width: 50px;
    height: 50px;
    border-radius: 0;
    text-align: center;
    padding: 0;
    cursor: pointer;
    appearance: none;
  }

  .custom-form textarea,
  .custom-form input[type='text'],
  .custom-form input[type='email'],
  .custom-form input[type='password'],
  .custom-form input[type='button'] {
    float: left;
    border: 1px solid #eee;
    background: #f9f9f9;
    width: 100%;
    padding: 15px 20px 15px 55px;
    border-radius: 6px;
    color: #666;
    font-size: 13px;
    appearance: none;
  }

  .custom-form input {
    margin-bottom: 20px;
  }

  .custom-form .quantity input.qty {
    color: #fff;
    width: 100px;
    border-right: none;
    border-left: none;
    cursor: default;
    appearance: none;
    background: #70243b;
  }

  .custom-form .quantity input.minus,
  .custom-form .quantity input.plus,
  .custom-form .quantity input.qty {
    width: 50px;
    height: 50px;
    border-radius: 0;
    text-align: center;
    padding: 0;
    cursor: pointer;
    appearance: none;
  }

  .list-author-widget-header {
    padding: 70px 20px;
    background: #70243b;
  }

  .shapes-bg-small:before {
    background-attachment: scroll;
    background-size: cover;
    background-image: url('https://dummyimage.com/300x300/000/fff');
  }

  .shapes-bg-small:before,
  .shapes-bg-big:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-repeat: repeat;
    opacity: 0.3;
  }

  .list-author-widget-link {
    display: inline-block;
    position: relative;
    top: -20px;
  }

  .list-author-widget-link a {
    color: #fff;
    font-weight: 600;
    font-size: 18px;
  }

  .list-author-widget-header img {
    position: absolute;
    width: 100px;
    border-radius: 100%;
    left: 50%;
    margin-left: -50px;
    bottom: -30px;
    border: 6px solid rgba(255, 255, 255, 0.2);
    border-radius: 100%;
  }

  .box-widget-content {
    float: left;
    width: 100%;
    position: relative;
    padding: 25px 30px 30px;
  }

  .list-author-widget-contacts {
    margin-top: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #eee;
    float: left;
    width: 100%;
  }

  .list-author-widget-contacts li {
    float: left;
    width: 100%;
    margin-bottom: 15px;
  }

  .list-author-widget-contacts li span {
    min-width: 80px;
  }

  .list-author-widget-contacts li span,
  .list-author-widget-contacts li a {
    float: left;
    text-align: left;
    font-weight: 500;
  }

  .list-author-widget-contacts li span i {
    margin-right: 7px;
    font-size: 14px;
    color: #70243b;
  }

  .gallery-item,
  .grid-sizer {
    width: 33.3%;
    position: relative;
    float: left;
  }

  .grid-small-pad .grid-item-holder {
    padding: 10px 20px 10px 0;
  }

  .grid-item-holder {
    float: left;
    width: 100%;
    height: auto;
    position: relative;
    overflow: hidden;
  }

  .list-single-gallery .box-item {
    border-radius: 6px;
  }

  .box-item {
    float: left;
    width: 100%;
    position: relative;
    overflow: hidden;
  }

  .box-item:before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: 2;
    background: rgba(51, 51, 51, 0.41);
    -webkit-transition: all 300mslinear;
    transition: all 300mslinear;
  }

  element.style {
    opacity: '1';
  }

  .gallery-item img,
  .grid-sizer img {
    width: 100%;
    height: auto;
    position: relative;
    z-index: 1;
  }

  img {
    border: 0;
    -ms-interpolation-mode: bicubic;
    vertical-align: middle;
  }

  .list-single-gallery .box-item a.gal-link {
    top: -50%;
    left: 50%;
    margin: -20px 0 0 -20px;
  }

  .box-item a.gal-link {
    position: absolute;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 100%;
    color: #fff;
    z-index: 10;
    -webkit-transition: all 300mslinear;
    transition: all 300mslinear;
  }

  .list-single-gallery .box-item:hover a.gal-link {
    top: 50%;
  }

  @media (min-width: 768px) {
  }

  @media (min-width: 992px) {
  }

  @media (min-width: 1200px) {
    .col-md-8 {
      width: 66.66666667%;
    }

    .col-md-1,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-10,
    .col-md-11,
    .col-md-12 {
      float: left;
    }

    .col-md-1,
    .col-md-2,
    .col-md-3,
    .col-md-4,
    .col-md-5,
    .col-md-6,
    .col-md-7,
    .col-md-8,
    .col-md-9,
    .col-md-10,
    .col-md-11,
    .col-md-12 {
      float: left;
    }

    .col-md-4 {
      width: 33.33333333%;
    }
  }
</style>
